import { Toaster, TooltipProvider } from "@motley/design"
import type { ReactNode } from "react"

type Props = {
  children: ReactNode
}

export default function UiProvider({ children }: Props) {
  // No theme provider: the design system's stylesheet answers
  // prefers-color-scheme before any JavaScript runs, and useTheme() needs none.
  return (
    <TooltipProvider>
      {children}
      <Toaster />
    </TooltipProvider>
  )
}
